import styled from 'styled-components'

// Legacy "pill" panel originally exported from orders/azmanotmain/SelectBar.
// Kept here as the shared source of truth for screens that still rely on it
// (cefi, controlPallets, likutExpress family, arizot, teudat). Newer
// screens (orders SelectBar, modalAzmanot, modalEditAzmana) define their
// own panel locally and do not import this one.
export const SelectPanelWrapper = styled.div`
    position: relative;
    width: 100%;
    min-height: 4.5em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5em;
    background: #fdfdfd;
    padding: 0 0.5em;
    border-radius: 40px;
    -webkit-box-shadow: -2px 8px 2px -6px rgba(41, 127, 118, 0.71);
    box-shadow: -2px 8px 2px -6px rgba(41, 127, 118, 0.71);
`

export default SelectPanelWrapper
